import { Injectable } from '@angular/core';
import { BaseHttpService } from '../shared-services/base-http.service';
import { ApiUrlsConstant } from '../../../app-constant';
import { Product } from '../../models/product-models';
import { BehaviorSubject } from 'rxjs';
import { CountryVm } from '../../models/country-vm';

@Injectable({
  providedIn: 'root'
})

export class CatalogueService extends BaseHttpService {
  apiUrls: any = ApiUrlsConstant;
  public cartItemList : any =[]
  public productList = new BehaviorSubject<any>([]);
 
  getCountryList(flag: boolean){
    return this.get<CountryVm[]>(`${this.apiUrls.getCatalogueCountry}?IsCatalogView=${flag}`);
 }
 
  loadProductList(countryIsoCode: string){
    const params = { countryIsoCode };
     return this.get<Product[]>(`${this.apiUrls.getCatalogueView}?Country_ISOCode=${countryIsoCode}`);
  }
  addtoCart(product : any){
    this.cartItemList.push(product);
    this.productList.next(this.cartItemList);
    console.log(this.cartItemList)
  }
  getProducts(){
    return this.productList.asObservable();
  }
}

